import PropTypes from "prop-types";
import React from "react";
import  Icon1  from "../../icons/Icon1/Icon1";
import "./style.scss";

const Button = ({
  state,
  type,
  icon,
  size,
  className,
  onClick,
  text,
  divClassName,
  override = <Icon1 className="icon-1" />,
  text1 = "Browse the Marketplace",
}) => {
  return (
    <div className={`button ${type} ${className}`} onClick={onClick} style={{cursor:'pointer'}}>
      {!icon && (
        <div className={`primary-button ${divClassName}`}>
          {type === "primary" && <>{text}</>}

          {type === "secondary" && <>{text}</>}
        </div>
      )}

      {icon && (
        <>
          {override}
          <div className="secondary-button">
            {type === "secondary" && <>{text}</>}

            {type === "primary" && <>{text}</>}
          </div>
        </>
      )}
    </div>
  );
};

Button.propTypes = {
  state: PropTypes.oneOf(["default"]),
  type: PropTypes.oneOf(["primary", "secondary"]),
  icon: PropTypes.bool,
  size: PropTypes.oneOf(["default"]),
  text: PropTypes.string,
  text1: PropTypes.string,
};

export default Button;